module.exports = __webpack_public_path__ + "static/media/4.ecce6b0f.jpg";